import React from 'react'
import { useSelector } from 'react-redux'
import CurriculumElementsCards from '../../../../../card/CurriculumElementsCards'
import LcElemensCards from '../../../../../card/LcElemensCards'
import CardGranularStep from './CardGranularStep'
import ContextMenuContent from './ContextMenu'
import DialogElementLevels from '../DialogElementLevels/DialogElementLevels'
import ScrollToBottom from 'react-scroll-to-bottom'
import DialogEvidenceOfLearning from '../EvidenceOfLearning/EvidenceOfLearning'
import DialogNote from '../Note/Note'
import MarkingUtils from '../../../../../../utils/marking.utils'
import { useParams } from 'react-router-dom'

const initialState = {
  mouseX: null,
  mouseY: null
}
const FormGranularStepsPreview = ({
  lcs = [],
  completed,
  onSetMarking,
  disabled,
  type = 'student-view',
  isBulk
}) => {
  const userId = useSelector((state) => state?.session?.user?.userId || '')
  const { classId, curriculumId, ulId } = useParams()
  const key = `hideLevels_${userId}_${classId}_${curriculumId}_${ulId}`
  const [state, setState] = React.useState(initialState)
  const [modal, setModal] = React.useState(null)
  const [dataHideLevels, setDataHideLevels] = React.useState({})
  const handleClick = (event, item) => {
    event.preventDefault()
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
      item
    })
  }

  const handleClose = (event, item) => {
    event.preventDefault()
    if (item && state.item) {
      if (item.type === 'marking') {
        const { lcId, granularSteps, markingLevel } = state.item
        const markinglevel = {
          ...markingLevel,
          completed: item._id
        }
        if (onSetMarking && markinglevel.completed) {
          onSetMarking(lcId, granularSteps, markinglevel)
        }
      } else {
        setModal({ type: item.type, form: state.item, action: 'create' })
      }
    }
    setState(initialState)
  }

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {}
  const maxMarking = currentCurriculum?.marking?.find((item) => item.maxValue) || {}
  const learningGrowth = useSelector((state) => state?.classMarking?.learningGrowth || [])
  const loadingLearningGrowth = useSelector((state) => state?.classMarking?.loadingLearningGrowth)

  const lcsElements = {}
  let levelsId = []
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId)
    levelsId = [...levelsId, ...lvls]
  })

  React.useEffect(() => {
    const readHideLevels = () => {
      const data = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {}
      setDataHideLevels(data || {})
    }

    readHideLevels()

    const handleStorage = (event) => {
      if (event.key && event.key !== key) return
      readHideLevels()
    }

    const handleCustom = (event) => {
      if (event?.detail?.key && event.detail.key !== key) return
      readHideLevels()
    }

    window.addEventListener('storage', handleStorage)
    window.addEventListener('hide-levels-updated', handleCustom)

    return () => {
      window.removeEventListener('storage', handleStorage)
      window.removeEventListener('hide-levels-updated', handleCustom)
    }
  }, [key])

  levelsId = [...new Set(levelsId)]
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position)
  const maxLevel = MarkingUtils.getMarkingLevel(
    currentCurriculum?.marking,
    currentCurriculum?.levels,
    lcs,
    completed
  )

  const visibleLevels = levelsRender?.filter((item) =>
    dataHideLevels[item._id] !== undefined ? dataHideLevels[item._id] : true
  )

  return (
    <ScrollToBottom className='w-full h-full' followButtonClassName='z-20'>
      <div className={['py-1 flex flex-col gap-1', lcs.length > 3 ? 'w-fit' : 'w-auto'].join(' ')}>
        {visibleLevels?.map((item, index) => (
          <React.Fragment key={`granular-steps-level-${item._id}`}>
            <CardGranularStep
              onSetMarking={onSetMarking}
              onContextMenu={handleClick}
              disabled={disabled}
              completed={completed}
              lcs={lcs}
              levelId={item._id}
              maxLevel={maxLevel}
              level={{
                ...item,
                primaryColor: minMarking?.primaryColor,
                secondaryColor: minMarking?.secondaryColor,
                levelIndex: index
              }}
              nextLevel={visibleLevels[index - 1]}
              marking={currentCurriculum.marking || []}
              minMarking={minMarking}
              maxMarking={maxMarking}
              onWorkedExamples={(form) => setModal({ type: 'worked-examples', form })}
              onEvidenceOfLearning={(form) =>
                setModal({ type: 'evidence-of-learning', form, action: 'edit' })
              }
              onNote={(form) => setModal({ type: 'note', form, action: 'edit' })}
              learningGrowth={type === 'learning-growth' ? learningGrowth : []}
              loadingLearningGrowth={loadingLearningGrowth}
              type={type}
              isBulk={isBulk}
            />
          </React.Fragment>
        ))}
        <LcElemensCards
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
        />
        <CurriculumElementsCards
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
        />
        <ContextMenuContent state={state} handleClose={handleClose} completed={completed} />
        {['worked-examples', 'teaching-suggestions'].includes(modal?.type) && (
          <DialogElementLevels
            open={['worked-examples', 'teaching-suggestions'].includes(modal?.type)}
            onClose={() => setModal(null)}
            formData={modal.form}
            element={modal.type}
          />
        )}
        {modal?.type === 'evidence-of-learning' && (
          <DialogEvidenceOfLearning
            open={modal?.type === 'evidence-of-learning'}
            onClose={() => setModal(null)}
            formData={modal.form}
            type={modal.action}
          />
        )}
        {modal?.type === 'note' && (
          <DialogNote
            open={modal?.type === 'note'}
            onClose={() => setModal(null)}
            formData={modal.form}
            type={modal.action}
          />
        )}
      </div>
    </ScrollToBottom>
  )
}

export default FormGranularStepsPreview
